import { IReturn } from "@/interfaces/Return";
import { NavigateFunction } from "react-router-dom";
import { NavigationRoutes } from "@/components/navigation/constants";
import { Entities, Roles } from "@/enums";
import {
  isPartiallyReceived,
  isSpecialSellerReturn,
} from "@/utils/partial-reception";

export const handleReturnClick = (
  item: IReturn,
  roles: string,
  navigation: NavigateFunction,
) => {
  if (roles.includes(Roles.SELLER_ROLE)) {
    if (
      (item.statutId === 3 || item.statutId === 5) &&
      item.isSellerVIP === true &&
      item.perRequest === true
    ) {
      navigation(NavigationRoutes.COLIS_SCAN); // PJ after
    } else if (
      (item.statutId === 3 || item.statutId === 5) &&
      item.isSellerVIP === true
    ) {
      navigation(NavigationRoutes.RETURN_DELIVERY_VALIDATION);
    } else {
      navigation(NavigationRoutes.RETURN_DETAILS);
    }
  } else if (roles.includes(Roles.DELIVERY_ROLE)) {
    if (isSpecialSellerReturn(item) || isPartiallyReceived(item)) {
      // Vendeur spécial: contrôle des articles puis BL cacheté à joindre. Une
      // réception déjà enregistrée rouvre le même écran avec sa sélection
      navigation(NavigationRoutes.PARTIAL_RECEPTION_VALIDATION);
      return;
    }
    if (item.statutId === 11) {
      navigation(NavigationRoutes.RETURN_PICK_UP_VALIDATION);
    }
    if (item.statutId === 3) {
      if (
        item.isSellerVIP === false &&
        (item.entityId === Entities.MILKRUN_ID ||
          item.entityId === Entities.RTO_MARJANE_ID)
      ) {
        // sending to colis scan page then to PJ
        navigation(NavigationRoutes.PJ);
      } else {
        navigation(NavigationRoutes.RETURN_DETAILS);
      }
    }
  } else if (roles.includes(Roles.HUB_ROLE)) {
    if (isSpecialSellerReturn(item) || isPartiallyReceived(item)) {
      // Vendeur spécial: contrôle des articles puis BL cacheté à joindre. Une
      // réception déjà enregistrée rouvre le même écran avec sa sélection
      navigation(NavigationRoutes.PARTIAL_RECEPTION_VALIDATION);
      return;
    }
    if (item.statutId === 5) {
      if (item.isSellerVIP === false) {
        navigation(NavigationRoutes.PJ); // PJ after
      } else {
        navigation(NavigationRoutes.RETURN_DETAILS);
      }
    } else if (item.statutId === 3) {
      navigation(NavigationRoutes.RETURN_DELIVERY_VALIDATION);
    } else {
      navigation(NavigationRoutes.RETURN_DETAILS);
    }
  } else if (roles.includes(Roles.EXPEDITION_ROLE)) {
    if (item.statutId === 2) {
      navigation(NavigationRoutes.RETURN_EXPEDITION_VALIDATION);
    } else {
      navigation(NavigationRoutes.RETURN_DETAILS);
    }
  } else {
    navigation(NavigationRoutes.RETURN_DETAILS);
  }
};
